import { createAction, props } from '@ngrx/store';

const GET_ALL_DATA_MODEL_TABLES = '[DataModel] Get All DataModel Tables';
const SET_ALL_DATA_MODEL_TABLES = '[DataModel] Set All DataModel Tables';
const GET_DATA_MODEL = '[DataModel] Get DataModel';
const SAVE_DATA_MODEL = '[DataModel] Save DataModel';
const SAVE_TABLE_FLD_DATA = '[DataModel] Save Table and Field';
const UPDATE_DATA_MODEL = '[DataModel] Update DataModel';
const DELETE_DATA_MODEL = '[DataModel] Delete DataModel';
const SET_DATA_MODEL = '[DataModel] SET DataModel';
const SAVE_DATA_MODEL_TREE_ORDER = '[DataModel TreeOrder Save] DataModel Page';
const UPDATE_DATA_MODEL_TREE_ORDER = '[DataModel TreeOrder Update] DataModel Page';
const GET_SCRIPTS = '[DataModel] Get Scripts';
const SAVE_TABLE_DATA = '[DataModel Table Save] DataModel Page';
const UPDATE_TABLE_DATA = '[DataModel Table Update] DataModel Page';
const DELETE_TABLE_DATA = '[DataModel Table Delete] DataModel Page';
const SAVE_FIELD_DATA = '[DataModel Field Save] DataModel Page';
const UPDATE_FIELD_DATA = '[DataModel Field Update] DataModel Page';
const DELETE_FIELD_DATA = '[DataModel Field Delete] DataModel Page';
const SAVE_FIELD_DATA_SUCCESS = '[DataModel Field Save / Update] DataModel Page';
const SAVE_FIELD_DATA_FAILURE = '[DataModel Field Save / Update Failure] DataModel Page';
const SAVE_TABLE_DATA_SUCCESS = '[DataModel Table Save / Update] DataModel Page';
const SAVE_TABLE_DATA_FAILURE = '[DataModel Table Save / Update Failure] DataModel Page';
const SET_TREE_ORDER = '[DataModel Tree order set] DataModel Page';
const GET_COMPLEX_MODEL = '[DataModel Complex DataType]  DataModel Page';
const SET_COMPLEX_MODEL = '[DataModel Complex DataType set]  DataModel Page';
const SAVE_ORDER_DATA_SUCCESS = '[DataModel Order Success] DataModel Page';
const SAVE_ORDER_DATA_FAILURE = '[DataModel Order Failure] DataModel Page';
const GET_FOREIGN_KEY = 'Get Foreign Key';
const UPDATE_FOREIGN_KEY = 'Update Foreign Key';
const SET_FOREIGN_KEY = 'Set Foreign Key';
const SET_ALL_TABLES = 'Set All Tables';
const DEL_FOREIGN_KEY = 'Delete Foreign Key';
const DEL_FK_ID = 'Deleted Foreign Key ID';
const UPD_FK_FAIL = 'Update Foreign Key Failure';
const DEL_FK_SUCC = 'Delete Foreign Key Success';
const DEL_FK_FAIL = 'Deleted Foreign Key Failure';
const UPD_FK_SUCC = 'Update Foreign Key Success';
const GETALL_FOREIGN_KEY = 'Get All Foreign Keys';
const SETALL_FOREIGN_KEY = 'Set All Foreign Keys';
const GET_LOOK = 'Get LookUp Table';
const SET_LOOK = 'Set LookUp Table';

const getAllDataModelTables = createAction(GET_ALL_DATA_MODEL_TABLES, props<{ datamodelApiConstants: any }>());

const setAllDataModelTables = createAction(GET_ALL_DATA_MODEL_TABLES, props<{ allDataModelTables: any }>());

const getDataModel = createAction(GET_DATA_MODEL, props<{ apiConstants: any }>());

const saveDataModel = createAction(SAVE_DATA_MODEL, props<{ apiConstants: any; datamodelData: any }>());

const updateDataModel = createAction(UPDATE_DATA_MODEL, props<{ datamodelApiConstants: any; datamodelData: any }>());

const deleteDataModel = createAction(DELETE_DATA_MODEL, props<{ datamodelId: string }>());

const setDataModel = createAction(SET_DATA_MODEL, props<{ datamodelData: any }>());
const getLookUpTables = createAction(GET_LOOK, props<{ apiConstants: any }>());

const setLookUpTables = createAction(SET_LOOK, props<{ lookUpTables: any }>());
const saveAppDatamodelBatch = createAction(SAVE_DATA_MODEL_TREE_ORDER, props<{ batchApiConstants: any; data: any }>());
const updateDataModelTreeOrder = createAction(
  UPDATE_DATA_MODEL_TREE_ORDER,
  props<{ datamodelApiConstants: any; orderInfo: any }>()
);

const saveTableData = createAction(SAVE_TABLE_DATA, props<{ datamodelApiConstants: any; tableData: any }>());

const saveTableFldData = createAction(SAVE_TABLE_FLD_DATA, props<{ datamodelApiConstants: any; tableFldData: any }>());
const getScripts = createAction(GET_SCRIPTS, props<{ rdbmsScriptApiConstants: any; params: any }>());

const updateTableData = createAction(UPDATE_TABLE_DATA, props<{ datamodelApiConstants: any; tableData: any }>());

const deleteTableData = createAction(DELETE_TABLE_DATA, props<{ datamodelApiConstants: any; tableId: any }>());

const saveDatamodelData = createAction(SAVE_FIELD_DATA, props<{ datamodelApiConstants: any; fieldData: any }>());

const updateDatamodelData = createAction(UPDATE_FIELD_DATA, props<{ datamodelApiConstants: any; fieldData: any }>());

const deleteDatamodelData = createAction(DELETE_FIELD_DATA, props<{ datamodelApiConstants: any; fieldId: any }>());

const saveDatamodelTableSuccess = createAction(SAVE_TABLE_DATA_SUCCESS, props<{ tableResults: any }>());

const saveDatamodelDataSuccess = createAction(SAVE_FIELD_DATA_SUCCESS, props<{ results: any }>());

const saveDatamodelDataFailure = createAction(SAVE_FIELD_DATA_FAILURE, props<{ error: any }>());

const saveDatamodelTableFailure = createAction(SAVE_TABLE_DATA_FAILURE, props<{ tableError: any }>());

const saveDatamodelTreeSuccess = createAction(SAVE_ORDER_DATA_SUCCESS, props<{ treeResults: any }>());

const saveDatamodelTreeFailure = createAction(SAVE_ORDER_DATA_FAILURE, props<{ treeError: any }>());

const setTreeOrder = createAction(SET_TREE_ORDER, props<{ treeOrder: any }>());

const getComplexTypeTables = createAction(GET_COMPLEX_MODEL, props<{ datamodelApiConstants: any; params: any }>());

const getForeignKey = createAction(
  GET_FOREIGN_KEY,
  props<{ fkapiConstants: any, data: any }>()
);
const setComplexTypeTables = createAction(SET_COMPLEX_MODEL, props<{ complexTypeTables: any }>());

const updateForeignKey = createAction(UPDATE_FOREIGN_KEY, props<{ updfkapiConstants: any; foreignKeyData: any }>());

const setForeignKey = createAction(SET_FOREIGN_KEY, props<{ foreignKeyTbl: any }>());

const deleteForeignKey = createAction(
  DEL_FOREIGN_KEY,
  props<{ delApiConstants: any, data:any }>()
);

const setAllTables = createAction(SET_ALL_TABLES, props<{ allTables: any }>());

const deletedFKId = createAction(DEL_FK_ID, props<{ fkId: any }>());

const updateFKSuccess = createAction(UPD_FK_SUCC, props<{ fKSaveSuccess: any }>());

const updateFKFailure = createAction(UPD_FK_FAIL, props<{ fKSaveFailure: any }>());

const deleteFKSuccess = createAction(DEL_FK_SUCC, props<{ fkDelSuccess: any }>());

const deleteFKFailure = createAction(DEL_FK_FAIL, props<{ fkDelFailure: any }>());

const getAllForeignKeys = createAction(GETALL_FOREIGN_KEY, props<{ fkallapiConstants: any }>());

const setAllForeignKeys = createAction(SETALL_FOREIGN_KEY, props<{ allForeignKeys: any }>());

export {
  saveDatamodelTableSuccess,
  saveDatamodelTableFailure,
  getLookUpTables,
  setLookUpTables,
  getScripts,
  getAllDataModelTables,
  setAllDataModelTables,
  setComplexTypeTables,
  getDataModel,
  saveDataModel,
  updateDataModel,
  deleteDataModel,
  setDataModel,
  saveTableData,
  updateTableData,
  saveDatamodelData,
  updateDatamodelData,
  deleteDatamodelData,
  deleteTableData,
  updateDataModelTreeOrder,
  saveAppDatamodelBatch,
  saveTableFldData,
  saveDatamodelDataSuccess,
  saveDatamodelDataFailure,
  saveDatamodelTreeSuccess,
  saveDatamodelTreeFailure,
  setTreeOrder,
  getComplexTypeTables,
  getForeignKey,
  updateForeignKey,
  setForeignKey,
  setAllTables,
  deleteForeignKey,
  deletedFKId,
  updateFKFailure,
  deleteFKSuccess,
  deleteFKFailure,
  updateFKSuccess,
  getAllForeignKeys,
  setAllForeignKeys
};
